
/*============================================================================
Start of cart-related functionality
==============================================================================*/


function ajaxSubmitCart() { 
$cart = $("#cart");
$.ajax({
  url: '/cart.js',
  dataType: 'json',
  type: 'post',
  data: $cart.serialize(),

  success: function (data) { 
    //alert('1');
	refreshCart(data);
  }
  
});
}

function refreshCart(cart) { 
    $cartBtn = $("#CartCount span");
   
    if ($cartBtn) {  
      var value = $cartBtn.text() || '0';
      var cart_items_html = "";
      var $cart = $("#cart ul");
      
      //alert(shopCurrency);
      
      $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));
      $cart.find('li:not(:first)').remove();
      
    
      
      
      if (cart.item_count <= 0) { 
      var wheight = $(window).height();
        $("#added-box form").css("height", wheight - 170 );
        $cart.html('');
        $cart.append("<li class='empty_cart'>Your bag is empty</li>");  
        $cart.append('<div class="totals_wrapper no-border"> <div class="bottom_part">' +
		  '<div class="border_btn">'+
          '<div class="conshop"> Continue Shopping <svg style="color: white" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">'+
          '<path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" fill="white">'+
          '</path>'+
          '</svg>'+
          '</div>'+
          '</div>'+
          '</div>'+
          '</div>');
      
        $(".cart-button").removeClass('itemincart');             
        $(".cart-button").html('<a href="javascript:void(0);" id="cart-number" class="cart-button itemincart">' + cart.item_count + '</a>');
        $('.new-total-price').html(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));    
        $(".addbag_count").hide();
        
      }
      else
      { 
    
    var wheight = $(window).height();
    $("#added-box form").css("height", wheight - 250 );
      
        $("#added-box ul").removeClass("emptyUl");
        
        $.each(cart.items, function(index, item) {
         
             cart_items_html += '';
          cart_items_html += '<li class="cart_item last_cart_item">' +
			 '<div class="cart_image">' +
             '<img src="' + item.image.replace(/(\.[^.]*)$/, "_large$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" style="width:100%" />' +
             '</div>' +
			 '<div class="cart_item_right">' +
             '<div class="item-inn-f">'+
			 '<div class="item_title cart_item_title">' + item.title + '</div>' +
             '<div class="price item_price">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</div>' +
             '</div>'+
			 '<div class="item-in-s">' +
			 '<div class="mm-counter cart-quantity">' +
             '<span class="quantity-count minus ss-icon minus">'+
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash" viewBox="0 0 16 16">'+
              '<path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"></path>'+
              '</svg>'+
              '</span>'+
             '<input type="text" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" />' +
             '<span class="quantity-count plus ss-icon plus">'+
             '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">'+
             '<path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>'+
             '</svg>'+
             '</span>'+
             '</div>' +
             '<div class="removelink">' +
			 '<a href="javascript:void(0)" class="io" id="'+ item.variant_id +'">'+
             '<img src="https://cdn.shopify.com/s/files/1/0606/1948/9475/files/delete.svg?v=1675169712">'+
             '</a>'+
			 '</div>' +
			 '</div>' +
			 '</div>' +
			 '</li>' ; 
			 /*'<a href="' + item.url +'">' +
             '<strong class="price">' + Shopify.formatMoney(item.line_price, $cart.data('money-format')) + '</strong>' +
             '</a>' +
             '</li>';*/
        });
		
		
		cart_items_html += '<div class="totals_wrapper no-border"><p class="prop-war"><img src="https://cdn.shopify.com/s/files/1/0606/1948/9475/files/bw8pt.png?v=1679583091" width="15"><b>WARNING:</b> Cancer, Birth Defects, Reproductive Harm — www.P65Warnings.ca.gov.</p> <div class="bottom_part"><div class="subtotal"> <span>Subtotal:</span>' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) + '<span class="right-i">taxes calculated at checkout</span></div>' +
		  '<div class="border_btn">'+
          '<div type="submit" value="Checkout" class="action_button right cart__submit"> <div class="btn-in">  <a href="/checkout"class="cart__submit btn btn--small-wide" >  Checkout <span>→</span></a>'+

          '</div>'+  
          '</div>'+
          '</div>'
          '</div>'
          '</div>';
		
        $(".cart-button").addClass('itemincart');
        
        $(".cart-button").html('<a href="javascript:void(0);" id="cart-number" class="cart-button itemincart">(' +cart.item_count+ ')</a>');
          
        $('.new-total-price').html(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));  

        $cart.html(cart_items_html);
        //$cart.append(cart_items_html);
        $cart.find('li.cart_item:last').addClass('last_cart_item');
     
          if($('.currencies:visible option:selected').val()) {
            Currency.convertAll($cart.data('shop-currency'), $('.currencies:visible option:selected').val()); 
          }
		
        $(".cart-ajax-loader").show();
        
        setTimeout(function() {
          $(".cart-ajax-loader").hide();
        }, 199);
        
        
	
		$("#added-box-wrapper").delay(1000).addClass("open-bag");
        $("body").delay(1000).addClass('slideleft_body');
       
        
        $("#body_overlay").addClass("showoverlay");
        
        //alert('1');
        
		//$("#Prod_added_suc").html('added!');
        //$("body").addClass('slideleft_body');
        $("#Prod_added_suc").fadeIn(800);
        $("#Prod_added_suc").delay(3000).fadeOut(800); 
        $(".addbag_count").show();

 
      }
    }
$('.io').click(function(){
  var ID =$(this).attr('id');
     console.log(ID);
  $('body').addClass('op-pop');
   $('.rm-pop').addClass('vis');
   $('.do').attr('onclick','remove_item('+ID+');')

 
 });
  
  }  
  
function htmlEncode(value){ 
    if (value) {
        return $('<div/>').text(value).html(); 
    } else {
        return '';
    }} 	
	
function remove_item(id) {
  document.getElementById('updates_'+id).value = 0;
  ajaxSubmitCart();
}	
	
  
$(document).on("change", "#cart input", function() { 
  	//alert('1');
    ajaxSubmitCart();
});  
  
$(document).on("click", ".ss-icon.minus", function() {  
  	var quantity = parseInt($(this).next("input").val()); 
    var qty = quantity ;
    
    quantity -= 1;
    $(this).next("input").attr("value", quantity);
    
    if (qty <= 0) {
   		$(this).closest('li.cart_item').addClass('animated fadeOutUp')
      	setTimeout(ajaxSubmitCart, 500);
    } else {
      	ajaxSubmitCart();
      	$("#Prod_added_suc").hide();
    }
  });  

$(document).on("click", ".ss-icon.plus", function() { 
    var quantity = parseInt($(this).prev("input").val()); 
    quantity += 1;
    $(this).prev("input").attr("value", quantity);
    ajaxSubmitCart();
  	$("#Prod_added_suc").hide();
  });
  

$(document).on("submit",".product_form", function(e) { 
      e.preventDefault();
      var $addToCartForm = $(this);  
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
		
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(itemData) { 
    	  $.getJSON("/cart.js", function(cart) { 
            refreshCart(cart);
                window.location.href = '/cart';
            window.setTimeout(function(){ $('.cart-button').click(); }, 500);
          });    
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          //var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartBtn.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("Add to Basket").removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
});

$(document).ready(function(){


$(document).on('click', '.cstm_ad_to_cart', function(e) {
    e.preventDefault();
 document.dispatchEvent(new CustomEvent('theme:loading:start'));
    var ID = $(this).attr("var_id");
    console.log(ID);
 
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: $(this).attr("var_id")
        },
        dataType: 'json',
         success: function(itemData) { 
    	  $.getJSON("/cart.js", function(cart) { 
            refreshCart(cart);
            window.setTimeout(function(){ $('.cart-button').click(); }, 500);
          });    
        },
    });
});



 
  
 /*$('.add_to_cart,.add-c,.pop-cart-btn,.product-form__cart-submit').click(function(){

   var ID =$(this).attr('id');

   if (ID == 'add-7087262367939'){

     $('.ajaxcart__product.1').addClass('nothing');
     $('.ajaxcart__product.2').removeClass('nothing');
    
   }
   else{
     $('.ajaxcart__product.1').removeClass('nothing');
     $('.ajaxcart__product.2').addClass('nothing');
   }

 }); */


$('.io').click(function(){
  var ID =$(this).attr('id');
     console.log(ID);
  $('body').addClass('op-pop');
   $('.rm-pop').addClass('vis');
  
   $('.do').attr('onclick','remove_item('+ID+');')

 
 });
 $('.do,.pop,.pop-close').click(function(){
   $('body').removeClass('op-pop');
   $('.rm-pop').removeClass('vis');
   
}); 
  
  //bag card click to show close icon olny
 $('.cart-count').click(function(){
   window.location.href = '/cart';
   	
 }); 
  
 $('.box_patch,.conshop').click(function(){
    $("#added-box-wrapper").removeClass("open-bag");
   
   	$(".box_patch").fadeOut();
    $("body").removeClass('slideleft_body');
   $("body").removeClass('dr-open');
 });  

$('.close-button').click(function(){
    $(".healfast-cart-bg").removeClass("open-bag");
   $("body").removeClass('dr-open');
   	$(".box_patch").fadeOut();
    $("body").removeClass('slideleft_body');
 });  

  $('.add_to_cart.btn.nn').click(function(){
    $(".healfast-cart-bg").removeClass("open-bag");
   
 }); 

  
$('.con-cart .btn').click(function(){
    $(".healfast-cart-bg").removeClass("open-bag");
  $("body").addClass('slideleft_body');
    $("#added-box-wrapper").addClass("open-bag");
   	 	$(".box_patch").fadeIn();
  
 });  
  

  
  
});

	$(window).on('load resize', function () {

  var mycount = $('.site-header__icon.site-header__cart .site-header__cart-count span').text();
console.log(mycount);  
      var wheight = $(window).height();
  if (mycount <= 0) {
    $("#added-box form").css("height", wheight - 170 );
  }
  else{
    $("#added-box form").css("height", wheight - 250 );
  }

});